module.exports = __webpack_public_path__ + "media/images/icons/light-bulb-2a34c738dc37e779acc0e39b4c2bd7da.svg";